import React, { useEffect, useState } from "react";
import useApiFetchInfinite from "src/Hooks/Shared/useApiFetchInfinite";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import InfiniteScroll from "react-infinite-scroll-component";
import useAuth from "src/Hooks/Custom/useAuth";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import useApiFetch from "src/Hooks/Shared/useApiFetch";
import EndPoints from "src/Constants/EndPoints";
import Slider from "react-slick";
import useLoading from "src/Hooks/Custom/useLoading";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BusinessItem from "../BusinessItem/BusinessItem";
import { useTranslation } from "react-i18next";

type BusinessListProps = {
  endPoint: string;
  placeholderMessage: string;
  setPostData?: any;
  refechForParent?: any;
  setModalVisibility?: any;
  setDetailView: any;
  search?: string;
  setSearch?: any;
};

function BusinessList({
  endPoint,
  setPostData,
  refechForParent,
  setModalVisibility,
  setDetailView,
  search,
  setSearch
}: BusinessListProps) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const { user } = AppStateHandler.getState();
  const { loading } = useAuth();
  const { data: categoriesResponse } = useApiFetch(
    [EndPoints.businessCategoris],
    {}
  );

  const { Items: categories = [] } = categoriesResponse?.data ?? {};
  const getSaleUrl = `${endPoint}?limit=6&subId=${user?.username}`;
  const [saleUrl, setSaleUrl] = useState<string>(getSaleUrl);
  useEffect(() => {
    if (search !== '') {
      setSaleUrl(`${getSaleUrl}&search=${search}`);
    } else {
      setSaleUrl(getSaleUrl);

    }
  }, [search, getSaleUrl]);

  const [activeBtn, setActiveBtn] = useState<number>(0);
  const { data, refetch, status, fetchMore } = useApiFetchInfinite([saleUrl], {
    getFetchMore: (lastData) => {
      const nextPage = lastData?.data?.Page;
      const totalPages = lastData?.data?.TotalPages;

      return parseInt(nextPage ?? "1", 10) < totalPages
        ? `&page=${parseInt(nextPage ?? "1", 10) + 1}`
        : null;
    },
  });
  useLoading(status);

  if (typeof refechForParent === "function") {
    refechForParent(refetch);
  }

  const openCreatePostModal = (e: any) => {
    e.preventDefault();
    setModalVisibility(true);
  };

  if (data?.length === 0 && status === "loading") {
    return (
      <VisibilityToggle visible={loading}>
        <span className="spinner-border spinner-border-lg"></span>
        &nbsp;
      </VisibilityToggle>
    );
  }

  const arrayData = (Array.isArray(data) ? data : [])
    .map((_) => _.data.Items)
    .reduce((a, b) => a.concat(b), []);

  const sliderSettings = {
    className: "slider variable-width",
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 2,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const changeFilter = (category_id: number) => {
    setActiveBtn(category_id);
    if (category_id) {
      setSaleUrl((prevUrl) => prevUrl + "&category_id=" + category_id);
    } else {
      setSaleUrl(getSaleUrl);
    }
  };

  return (
    <InfiniteScroll
      dataLength={arrayData.length} //This is important field to render the next data
      next={fetchMore}
      hasMore={true}
      loader={
        <VisibilityToggle visible={loading}>
          <span className="spinner-border spinner-border-lg"></span>
          &nbsp;
        </VisibilityToggle>
      }
      endMessage={
        <p className="text-center">
          <b>Yay! You have seen it all</b>
        </p>
      }
      // below props only if you need pull down functionality
      refreshFunction={refetch}
      pullDownToRefresh
      pullDownToRefreshThreshold={50}
      pullDownToRefreshContent={
        <h3 className="text-center">&#8595; Pull down to refresh</h3>
      }
      releaseToRefreshContent={
        <h3 className="text-center">&#8593; Release to refresh</h3>
      }
    >
      <div className="d-flex justify-content-between mb-4 align-items-center px-3">
        <h3 className="fz16 mb-0">{t("Business")}</h3>
        <div className="d-flex align-items-center w-50 position-relative">
          <a href="/">
            <img
              src="/assets/images/plus.png"
              className={`img-fluid ${i18n.dir()==='rtl'?'ml-4':'mr-4'}`}
              onClick={openCreatePostModal}
              alt=""
            />
          </a>
          <input
            value={search}
            type="text"
            className={`form-control fz12 custom_input border-0 ${i18n.dir()==='rtl'?'Almarairegular':' poppinsregular'}`}
            placeholder={t("Search")}
            onChange={e => setSearch(e.target.value)}
          />
          <i className={` fa fa-search ${i18n.dir()==='rtl'?'fa-search-rtl':'fa-search-ltr'}`}></i>
        </div>
      </div>
      <div className="furniture_section">
        <div className="your-className furniture_btns mb-4 px-5 salelist_slick">
          <Slider  {...sliderSettings}>
            <div className="text-center m-3">
              <img
                src="https://houmti.s3.eu-central-1.amazonaws.com/sales-categories/all@3x.png"
                alt=""
                width="40"
                className="mx-auto cursor-pointer"
                onClick={() => changeFilter(0)}
              />
              <span
                className={(activeBtn === 0 ? "active-category fz11" : "fz11") + (lang === 'ar' ? " Almaraibold" : "")}
              >
                {t('All')}
              </span>
            </div>
            {categories.map((c: any, i: number) => (
              <div key={i} className="text-center m-3">
                <img
                  src={c.icon}
                  alt=""
                  width="40"
                  className="mx-auto cursor-pointer"
                  onClick={() => changeFilter(c.id)}
                />
                <span
                  className={
                    ( activeBtn === c.id ? "active-category fz11" : "fz11" ) + (lang === 'ar' ? " Almaraibold" : "")
                  }
                >
                  {lang === 'fr' ? c.fr_name : lang === 'ar' ? c.ar_name: c.name }
                </span>
              </div>
            ))}
          </Slider>
        </div>
        <div className="container-fluid">
          <div className="row mt-5">
            {arrayData.map((item: any, index: number) => (
              <BusinessItem
                key={index}
                {...item}
                refetch={refetch}
                setPostData={setPostData}
                setModalVisibility={setModalVisibility}
                setDetailView={setDetailView}
              />
            ))}
          </div>
        </div>
      </div>
    </InfiniteScroll>
  );
}

export default BusinessList;
